import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';

import { injectIntl } from 'components';

const styles = () => ({
  dialog: {
    maxWidth: 'none',
    width: '100%',
  },
  dialogContent: { width: '100%' },
});

class InventoryDescriptionDialog extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    info: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,

    formatMessage: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
  };

  render() {
    const {
      classes,
      info,
      open,

      formatMessage,
      onRequestClose,
    } = this.props;
    return (
      <Dialog
        classes={{
          paper: classes.dialogContent,
          root: classes.dialog,
        }}
        onClose={onRequestClose}
        open={open}
        scroll="body"
      >
        <DialogTitle>{formatMessage('Inventory Description')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {info}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={onRequestClose}
            variant="text"
          >
            {formatMessage('Cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const wrappedInventoryDescriptionDialog =
  withStyles(styles)(injectIntl(InventoryDescriptionDialog));
wrappedInventoryDescriptionDialog.displayName = 'InventoryDescriptionDialog';

export default wrappedInventoryDescriptionDialog;
